import * as React from 'react';

export default (props:any) => (
    <svg
        viewBox='0 0 24 24'
        {...props}
    >
        <path d="M3,22V8H7V22H3M10,22V2H14V22H10M17,22V14H21V22H17Z" />
    </svg>
)
